import { render, staticRenderFns } from "./TenderOffersColumn.vue?vue&type=template&id=303f831e&"
import script from "./TenderOffersColumn.vue?vue&type=script&lang=js&"
export * from "./TenderOffersColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports